// @ts-nocheck
import { apiRequest } from "./apiService";

/**
 * Save or update dashboard filters
 * @param {string} dashboardId - Unique identifier for the dashboard
 * @param {object} filters - Filter object containing status, dateRange, sortBy, etc.
 * @returns {object} { response, error }
 */
export const saveDashboardFilters = async (dashboardId, filters) => {
  const { response, error } = await apiRequest({
    method: "POST",
    url: `saveDashboardFilters/${dashboardId}`,
    data: { filters },
    isToken: true,
  });

  return { response, error };
};

/**
 * Get saved dashboard filters for current user
 * @param {string} dashboardId - Unique identifier for the dashboard
 * @returns {object} { response, error }
 */
export const getDashboardFilters = async (dashboardId) => {
  const { response, error } = await apiRequest({
    method: "GET",
    url: `getDashboardFilters/${dashboardId}`,
    data: null,
    isToken: true,
  });

  return { response, error };
};

/**
 * Delete saved dashboard filters
 * @param {string} dashboardId - Unique identifier for the dashboard
 * @returns {object} { response, error }
 */
export const deleteDashboardFilters = async (dashboardId) => {
  const { response, error } = await apiRequest({
    method: "DELETE",
    url: `deleteDashboardFilters/${dashboardId}`,
    data: null,
    isToken: true,
  });

  return { response, error };
};